// Six accessible text inputs preserve leading zeroes and support mobile OTP autofill.
export function mountOtpInput(container) {
  const inputs = Array.from({ length: 6 }, (_, index) => {
    const input = document.createElement('input');
    input.className = 'auth-input otp-digit'; input.type = 'text'; input.inputMode = 'numeric';
    input.autocomplete = index === 0 ? 'one-time-code' : 'off';
    input.setAttribute('aria-label', `Цифра ${index + 1} из 6`);
    input.pattern = '[0-9]'; input.name = `otp-${index}`;
    // Allow autofill/paste of the full code before distributing it.
    input.maxLength = 6;
    container.append(input); return input;
  });
  function insert(index, text) {
    const digits = text.replace(/\D/g, '').slice(0, 6);
    if (!digits) { inputs[index].value = ''; return; }
    const start = digits.length === 6 ? 0 : index;
    for (let n = 0; n < digits.length && start + n < 6; n++) inputs[start + n].value = digits[n];
    inputs[Math.min(start + digits.length, 5)].focus();
    inputs[Math.min(start + digits.length, 5)].select();
  }
  inputs.forEach((input, index) => {
    input.addEventListener('focus', () => input.select());
    input.addEventListener('input', () => insert(index, input.value));
    input.addEventListener('paste', event => {
      const text = event.clipboardData?.getData('text');
      if (text !== undefined) { event.preventDefault(); insert(index, text); }
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Backspace' && !input.value && index > 0) {
        event.preventDefault(); inputs[index - 1].value = ''; inputs[index - 1].focus();
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); inputs[Math.max(0, Math.min(5, index + (event.key === 'ArrowLeft' ? -1 : 1)))].focus();
      }
    });
  });
  return { value: () => inputs.map(x => x.value).join(''), clear: () => inputs.forEach(x => { x.value = ''; }),
    complete: () => inputs.every(x => /^\d$/.test(x.value)), focus: () => inputs[0].focus() };
}
